import script from "./download-form.vue?vue&type=script&setup=true&lang=js"
export * from "./download-form.vue?vue&type=script&setup=true&lang=js"

import "./download-form.vue?vue&type=style&index=0&id=56b0a63f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56b0a63f"]])

export default __exports__